/*
============================================
CLUSTER A/B TEST: Cart Free Shipping Progress
Test ID: b2e501bc-d2bb-499a-883c-40927b45afaf
Control Variant ID: 57fe79a6-dab2-4f79-8322-d04a7d2b1612
Treatment Variant ID: 0bb2b69b-9be9-4477-bc65-97c20c09d08d
============================================
*/
(function() {
  var TEST_ID = 'b2e501bc-d2bb-499a-883c-40927b45afaf';
  var CONTROL_VARIANT_ID = '57fe79a6-dab2-4f79-8322-d04a7d2b1612';
  var TREATMENT_VARIANT_ID = '0bb2b69b-9be9-4477-bc65-97c20c09d08d';

  var FREE_SHIPPING_THRESHOLD_CENTS = 9900;
  var FREE_SHIPPING_SEAL_IMAGE_URL =
    'https://cdn.shopify.com/s/files/1/1915/6645/files/TGS_free_shipping_stamp_250px.png?v=1629411174';
  var MANAGED_SEAL_CLASS = 'cluster-managed-free-shipping-seal';
  var STYLE_ID = 'cluster-cart-free-shipping-progress-style';
  var HOST_CLASS = 'cluster-cart-free-shipping-host';
  var COMPONENT_ID = 'cluster-cart-free-shipping-progress';

  var currentVariant = 'control';
  var mutationObserver = null;
  var refreshTimer = null;
  var activeRequest = null;
  var listenersBound = false;

  function onCartInteractionClick(event) {
    var trigger = event.target && event.target.closest('[data-update-quantity], [data-cart-page-delete]');
    if (trigger) scheduleRefresh();
  }

  function onCartInteractionChange(event) {
    if (event.target && event.target.matches('.quantity-input')) {
      scheduleRefresh();
    }
  }

  function getAssignments() {
    if (window.cluster_ctx && Array.isArray(window.cluster_ctx.assignments)) {
      return window.cluster_ctx.assignments;
    }
    if (window.__clusterDebug && Array.isArray(window.__clusterDebug.assignments)) {
      return window.__clusterDebug.assignments;
    }
    return null;
  }

  function getAssignedVariant() {
    var assignments = getAssignments();
    if (!assignments) return null;

    for (var i = 0; i < assignments.length; i++) {
      var assignment = assignments[i];
      if (!assignment || assignment.testId !== TEST_ID) continue;

      if (assignment.variantId === TREATMENT_VARIANT_ID) return 'treatment';
      if (assignment.variantId === CONTROL_VARIANT_ID) return 'control';

      if (assignment.variant && typeof assignment.variant.isControl === 'boolean') {
        return assignment.variant.isControl ? 'control' : 'treatment';
      }
    }

    return null;
  }

  function isCartPage() {
    return (
      document.body &&
      (/(^|\s)cart(\s|$)/.test(document.body.className) || window.location.pathname.indexOf('/cart') === 0)
    );
  }

  function formatUsd(cents) {
    var absolute = Math.max(0, cents);
    var dollars = (absolute / 100).toFixed(2);
    dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + dollars;
  }

  function getCurrentCurrencyCode(cart) {
    var code = '';

    if (cart) {
      if (typeof cart.currency === 'string') {
        code = cart.currency;
      } else if (cart.currency && typeof cart.currency.iso_code === 'string') {
        code = cart.currency.iso_code;
      } else if (typeof cart.presentment_currency === 'string') {
        code = cart.presentment_currency;
      }
    }

    if (!code && window.Shopify && window.Shopify.currency) {
      if (typeof window.Shopify.currency.active === 'string') {
        code = window.Shopify.currency.active;
      } else if (typeof window.Shopify.currency.currentCurrency === 'string') {
        code = window.Shopify.currency.currentCurrency;
      } else if (typeof window.Shopify.currency === 'string') {
        code = window.Shopify.currency;
      }
    }

    return typeof code === 'string' ? code.toUpperCase() : '';
  }

  function isUsdCurrency(cart) {
    var currencyCode = getCurrentCurrencyCode(cart);
    return !currencyCode || currencyCode === 'USD';
  }

  function getCurrentLanguageCode() {
    var code = '';

    if (document.body && document.body.dataset && typeof document.body.dataset.currentLang === 'string') {
      code = document.body.dataset.currentLang;
    }

    if (!code && document.documentElement && typeof document.documentElement.lang === 'string') {
      code = document.documentElement.lang;
    }

    if (!code && window.Shopify && typeof window.Shopify.locale === 'string') {
      code = window.Shopify.locale;
    }

    return typeof code === 'string' ? code.toLowerCase() : '';
  }

  function isEnglishLanguage() {
    var languageCode = getCurrentLanguageCode();
    if (!languageCode) return false;
    var normalizedCode = languageCode.split('-')[0].split('_')[0];
    return normalizedCode === 'en';
  }

  function isEligibleLanguageAndCurrency(cart) {
    return isEnglishLanguage() && isUsdCurrency(cart);
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.' + HOST_CLASS + ' {',
      '  width: 100%;',
      '  margin: 0 auto 24px;',
      '  padding: 0 10px;',
      '  box-sizing: border-box;',
      '}',
      '#' + COMPONENT_ID + ' {',
      '  width: 100%;',
      '  max-width: 570px;',
      '  margin: 0 auto;',
      '  padding: 8px 0 10px;',
      '}',
      '#' + COMPONENT_ID + ' .cluster-cart-free-shipping__message {',
      '  margin: 0 0 16px;',
      '  text-align: center;',
      '  font-size: 21px;',
      '  line-height: 1.2;',
      '  font-weight: 700;',
      '  color: #3d6484;',
      '}',
      '#' + COMPONENT_ID + ' .cluster-cart-free-shipping__track-wrap {',
      '  position: relative;',
      '  padding: 10px 0 26px;',
      '}',
      '#' + COMPONENT_ID + ' .cluster-cart-free-shipping__track {',
      '  height: 14px;',
      '  border-radius: 999px;',
      '  background: #d7d8da;',
      '  overflow: hidden;',
      '}',
      '#' + COMPONENT_ID + ' .cluster-cart-free-shipping__fill {',
      '  height: 100%;',
      '  width: 0%;',
      '  border-radius: 999px;',
      '  background: #0e273e;',
      '  transition: width 220ms ease-out;',
      '}',
      '#' + COMPONENT_ID + ' .cluster-cart-free-shipping__marker {',
      '  position: absolute;',
      '  right: 0;',
      '  top: 28px;',
      '  transform: none;',
      '  display: flex;',
      '  flex-direction: row;',
      '  align-items: center;',
      '  gap: 4px;',
      '}',
      '#' + COMPONENT_ID + ' .cluster-cart-free-shipping__label {',
      '  text-align: right;',
      '  font-size: 11px;',
      '  line-height: 1.2;',
      '  white-space: nowrap;',
      '  font-weight: 700;',
      '  text-transform: uppercase;',
      '  letter-spacing: 0.2px;',
      '  color: #3d6484;',
      '}',
      '@media only screen and (max-width: 798px) {',
      '  #' + COMPONENT_ID + ' {',
      '    width: 90%;',
      '    margin: 0 auto;',
      '    padding: 8px 0 10px;',
      '  }',
      '  #' + COMPONENT_ID + ' .cluster-cart-free-shipping__message {',
      '    font-size: 18px;',
      '    margin-bottom: 14px;',
      '  }',
      '  #' + COMPONENT_ID + ' .cluster-cart-free-shipping__track-wrap {',
      '    padding-bottom: 24px;',
      '  }',
      '  #' + COMPONENT_ID + ' .cluster-cart-free-shipping__label {',
      '    font-size: 11px;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function ensureHost() {
    var host = document.querySelector('.' + HOST_CLASS);
    if (host) return host;

    host = document.createElement('div');
    host.className = HOST_CLASS + ' container';

    var topMessageWrapper = document.querySelector('.top-message-wrapper');
    if (topMessageWrapper && topMessageWrapper.parentNode) {
      topMessageWrapper.parentNode.insertBefore(host, topMessageWrapper);
      return host;
    }

    var cartForm = document.querySelector('.cart__form');
    if (cartForm && cartForm.parentNode) {
      cartForm.parentNode.insertBefore(host, cartForm);
      return host;
    }

    return null;
  }

  function ensureComponent() {
    var host = ensureHost();
    if (!host) return null;

    var component = document.getElementById(COMPONENT_ID);
    if (component) return component;

    component = document.createElement('div');
    component.id = COMPONENT_ID;
    component.innerHTML = [
      '<p class="cluster-cart-free-shipping__message" data-cluster-fs-message></p>',
      '<div class="cluster-cart-free-shipping__track-wrap">',
      '  <div class="cluster-cart-free-shipping__track">',
      '    <div class="cluster-cart-free-shipping__fill" data-cluster-fs-fill></div>',
      '  </div>',
      '  <div class="cluster-cart-free-shipping__marker">',
      '    <span class="cluster-cart-free-shipping__label">Free Shipping</span>',
      '  </div>',
      '</div>'
    ].join('');

    host.appendChild(component);
    return component;
  }

  function removeTreatmentUi() {
    var host = document.querySelector('.' + HOST_CLASS);
    if (host) {
      host.remove();
    }
  }

  function getSealCandidates() {
    return document.querySelectorAll('.top-message-wrapper .free-shipping-seal, .free-shipping-seal.' + MANAGED_SEAL_CLASS);
  }

  function ensureFreeShippingSeal() {
    var existing = document.querySelector('.top-message-wrapper .free-shipping-seal, .free-shipping-seal.' + MANAGED_SEAL_CLASS);
    if (existing) return existing;

    var topMessageWrapper = document.querySelector('.top-message-wrapper');
    if (!topMessageWrapper) {
      var host = document.querySelector('.' + HOST_CLASS);
      if (!host) return null;

      var fallbackSeal = document.createElement('div');
      fallbackSeal.className = 'free-shipping-seal ' + MANAGED_SEAL_CLASS;
      fallbackSeal.innerHTML = '<img src="' + FREE_SHIPPING_SEAL_IMAGE_URL + '" alt="Free shipping seal">';
      host.parentNode.insertBefore(fallbackSeal, host.nextSibling);
      return fallbackSeal;
    }

    var seal = document.createElement('div');
    seal.className = 'free-shipping-seal ' + MANAGED_SEAL_CLASS;
    seal.innerHTML = '<img src="' + FREE_SHIPPING_SEAL_IMAGE_URL + '" alt="Free shipping seal">';
    topMessageWrapper.insertBefore(seal, topMessageWrapper.firstChild);
    return seal;
  }

  function updateFreeShippingSeal(isUnlocked) {
    if (isUnlocked) {
      var ensuredSeal = ensureFreeShippingSeal();
      if (!ensuredSeal) return;
    }

    var seals = getSealCandidates();
    if (!seals || !seals.length) return;

    for (var i = 0; i < seals.length; i++) {
      seals[i].style.display = isUnlocked ? '' : 'none';
    }
  }

  function fetchCartState() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Unable to load cart state');
      return response.json();
    });
  }

  function renderProgress(cart) {
    if (!isEligibleLanguageAndCurrency(cart)) {
      removeTreatmentUi();
      updateFreeShippingSeal(false);
      return;
    }

    var component = ensureComponent();
    if (!component || !cart) return;

    var subtotalCents = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
    if (typeof subtotalCents !== 'number') subtotalCents = 0;

    var remainingCents = Math.max(0, FREE_SHIPPING_THRESHOLD_CENTS - subtotalCents);
    var progressPercent = Math.max(0, Math.min(100, (subtotalCents / FREE_SHIPPING_THRESHOLD_CENTS) * 100));
    var isUnlocked = remainingCents <= 0;

    var messageNode = component.querySelector('[data-cluster-fs-message]');
    var fillNode = component.querySelector('[data-cluster-fs-fill]');

    if (messageNode) {
      if (isUnlocked) {
        messageNode.textContent = 'Free shipping unlocked';
      } else {
        messageNode.textContent = 'You are ' + formatUsd(remainingCents) + ' away from free shipping.';
      }
    }

    if (fillNode) {
      fillNode.style.width = progressPercent.toFixed(2) + '%';
    }

    updateFreeShippingSeal(isUnlocked);
    component.classList.toggle('is-unlocked', isUnlocked);
  }

  function scheduleRefresh() {
    if (currentVariant !== 'treatment') return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshTreatmentUi, 220);
  }

  function refreshTreatmentUi() {
    if (!isCartPage() || currentVariant !== 'treatment') return;
    if (activeRequest) return;
    if (!isEligibleLanguageAndCurrency()) {
      removeTreatmentUi();
      updateFreeShippingSeal(false);
      return;
    }

    activeRequest = fetchCartState()
      .then(function(cart) {
        renderProgress(cart);
      })
      .catch(function() {})
      .finally(function() {
        activeRequest = null;
      });
  }

  function startObservers() {
    if (mutationObserver) return;

    var observedNode = document.querySelector('.cart__form') || document.body;
    if (!observedNode) return;

    mutationObserver = new MutationObserver(function() {
      scheduleRefresh();
    });

    mutationObserver.observe(observedNode, {
      childList: true,
      subtree: true
    });

    if (!listenersBound) {
      document.addEventListener('click', onCartInteractionClick, true);
      document.addEventListener('change', onCartInteractionChange, true);
      listenersBound = true;
    }
  }

  function stopObservers() {
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }
    clearTimeout(refreshTimer);
    refreshTimer = null;
    if (listenersBound) {
      document.removeEventListener('click', onCartInteractionClick, true);
      document.removeEventListener('change', onCartInteractionChange, true);
      listenersBound = false;
    }
  }

  function applyVariant(variant) {
    currentVariant = variant === 'treatment' ? 'treatment' : 'control';
    var isTreatment = currentVariant === 'treatment' && isCartPage();

    document.documentElement.classList.toggle('is-cart-free-shipping-progress-treatment', isTreatment);

    if (isTreatment) {
      ensureStyles();
      startObservers();
      refreshTreatmentUi();
    } else {
      stopObservers();
      removeTreatmentUi();
    }
  }

  function resolveAndApply() {
    var assignedVariant = getAssignedVariant();
    applyVariant(assignedVariant || 'control');
    return assignedVariant;
  }

  window.isCartFreeShippingProgressTreatment = function() {
    return currentVariant === 'treatment';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      resolveAndApply();
    });
  } else {
    resolveAndApply();
  }

  var attempts = 0;
  var maxAttempts = 80;
  var pollInterval = setInterval(function() {
    attempts += 1;
    var assignedVariant = getAssignedVariant();
    if (assignedVariant) {
      applyVariant(assignedVariant);
      clearInterval(pollInterval);
      return;
    }
    if (attempts >= maxAttempts) {
      clearInterval(pollInterval);
    }
  }, 250);
})();
